module.exports = __webpack_public_path__ + "images/29727da53a42ab74b49c8f27f2c2056f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/new-trans.png
// module id = 1274
// module chunks = 0